import React from 'react'
// libs
import { useQuery } from '@apollo/client/react'
import { useSelector } from 'react-redux'
import { formValueSelector } from 'redux-form'
// components
import AiUsageMetricsRow from './components/Metrics'
// constants
import { Forms } from 'constants/forms'
// types
import { IAiUsageStats } from 'types/graphql'
// views
import { Amount, AmountDescription, Card, Header, HeaderLeft, MetaItem, MetaLine, Separator, Title } from './views'
// graphql
import { AI_USAGE_QUERY } from 'graphql/ai/queries'
// utils
import moment from 'moment'

interface StatsResponse {
  aiUsageStats: IAiUsageStats
}

const UsedCard: React.FC = () => {
  const { startPeriod, endPeriod, user } = useSelector((state) => ({
    user: formValueSelector(Forms.AI_USAGE_FILTER_FORM)(state, 'user'),
    endPeriod: formValueSelector(Forms.AI_USAGE_FILTER_FORM)(state, 'endPeriod'),
    startPeriod: formValueSelector(Forms.AI_USAGE_FILTER_FORM)(state, 'startPeriod')
  }))

  const { data } = useQuery<StatsResponse>(AI_USAGE_QUERY, {
    variables: {
      filter: {
        dateFrom: startPeriod,
        dateTo: endPeriod,
        userId: user?.value
      }
    }
  })

  const { totalCost = 0, totalConversations = 0 } = data?.aiUsageStats || {}

  const formattedPeriod = `${moment(startPeriod).format('DD.MM.YYYY')} — ${moment(endPeriod).format('DD.MM.YYYY')}`

  const showMeta = user || (endPeriod && startPeriod)

  return (
    <Card>
      <Header>
        <HeaderLeft>
          <Title>AI Usage</Title>
          {showMeta && (
            <MetaLine>
              {endPeriod && startPeriod && <MetaItem>{formattedPeriod}</MetaItem>}
              {user?.value && (
                <>
                  <Separator />
                  <MetaItem>{user.label}</MetaItem>
                </>
              )}
            </MetaLine>
          )}
        </HeaderLeft>
      </Header>

      <Amount>{`$${totalCost.toFixed(2)}`}</Amount>
      <AmountDescription>Total cost for selected period</AmountDescription>
      <AiUsageMetricsRow totalConversations={totalConversations} />
    </Card>
  )
}

export default UsedCard
